module.exports = __webpack_public_path__ + "static/licensing-sm-783902773347a536b603b6041e48782c.jpg";